module.exports = __webpack_public_path__ + "static/img/2.66fc2d8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/gallery/2.jpg
// module id = 420
// module chunks = 1